import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { common, wallet } from "../../types";
// import { ApiResponse } from "../../components/organisms/Wallet/WalletUseCoinsList";
// import { Images } from "../../constants";

const walletInitialState: wallet.WalletStateType = {
  walletAmount: {
    balance: 0,
    programs: [],
    isLoading: false,
    error: "",
  },
  walletStatement: {
    count: 0,
    entity: "",
    items: [],
    total_count: 0,
    error: "",
    isLoading: false,
    isLastPageReached: false,
  },
  createWalletId: {
    error: "",
    isLoading: false,
    walletDetails: undefined,
  },
  loadWalletMoney: {
    error: "",
    isLoading: false,
  },
  walletOptionPlans: {
    error: "",
    data: [],
    isLoading: false,
  },
  coinsValue: 1,
  walletRuleEngine: undefined,
  fetchWalletAmount: false,
  showModalForEarnCoins: {
    modalVisible: false,
    type: undefined,
  },
  currentUsedWalletMoney: 0,
};

export const walletSlice = createSlice({
  name: "wallet",
  initialState: walletInitialState,
  reducers: {
    /* This action will trigger our saga middleware
               and set the loader to true and reset error message.
            */

    // wallet coins api
    fetchwalletOptionPlansRequest: (
      state: wallet.WalletStateType,
      _action: PayloadAction<any>
    ) => {
      state.walletOptionPlans.error = "";
      state.walletOptionPlans.isLoading = true;
    },
    fetchwalletOptionPlansSuccess: (
      state: wallet.WalletStateType,
      _action: PayloadAction<common.ResponseGenerator>
    ) => {
      state.walletOptionPlans.isLoading = false;
      const tempData = _action.payload?.data?.map((item: any) => ({
        image_url: item?.image_url,
        plan_master_id: item?.plan_master_id,
        fromAPI: true,
      }));
      tempData.unshift({
        image_url: "", //Images.WalletCareProduct,
        fromAPI: false,
        plan_master_id: "CARE_PRODUCTS",
      });
      tempData.push({
        image_url: "", //Images.WalletBookLabTest,
        fromAPI: false,
        plan_master_id: "BOOK_LAB_TESTS",
      });
      state.walletOptionPlans.data = tempData;
    },
    fetchwalletOptionPlansError: (
      state: wallet.WalletStateType,
      { payload: error }: PayloadAction<string>
    ) => {
      state.walletOptionPlans.isLoading = false;
      state.walletOptionPlans.error = error;
    },

    // wallet amount api
    fetchWalletAmountRequest: (
      state: wallet.WalletStateType,
      _action: PayloadAction<any>
    ) => {
      state.walletAmount.error = "";
      state.walletAmount.isLoading = true;
    },
    fetchWalletAmountSuccess: (
      state: wallet.WalletStateType,
      _action: PayloadAction<common.ResponseGenerator>
    ) => {
      state.walletAmount.isLoading = false;
      state.walletAmount.balance = _action?.payload?.data?.balance ?? 0;
      state.walletAmount.programs = _action?.payload?.data?.programs ?? [];
      state.fetchWalletAmount = false;
    },
    fetchWalletAmountError: (
      state: wallet.WalletStateType,
      { payload: error }: PayloadAction<string>
    ) => {
      state.walletAmount.isLoading = false;
      state.fetchWalletAmount = false;
      state.walletAmount.error = error;
    },

    // fetch-statement api
    fetchWalletStatementRequest: (
      state: wallet.WalletStateType,
      _action: PayloadAction<any>
    ) => {
      state.walletStatement.error = "";
      state.walletStatement.isLoading = true;
    },
    fetchWalletStatementSuccess: (
      state: wallet.WalletStateType,
      _action: PayloadAction<any>
    ) => {
      state.walletStatement.isLoading = false;
      state.walletStatement.items =
        _action.payload?.page_no == 0
          ? _action?.payload?.data.items ?? []
          : [
              ...(state.walletStatement.items ?? []),
              ...(_action?.payload?.data.items ?? []),
            ];
      state.walletStatement.total_count = _action?.payload?.data.total_count;
      state.walletStatement.count = _action?.payload?.data.count;
      if (_action.payload?.filter) {
        state.walletStatement.isLastPageReached =
          state.walletStatement.items.length ==
            _action?.payload?.data.total_count ||
          (state.walletStatement.items ?? [])?.length <
            _action?.payload?.data.total_count
            ? true
            : false;
      } else {
        state.walletStatement.isLastPageReached =
          (state.walletStatement.items ?? [])?.length <
          _action?.payload?.data.total_count
            ? false
            : true;
      }
    },
    fetchWalletStatementError: (
      state: wallet.WalletStateType,
      { payload: error }: PayloadAction<string>
    ) => {
      state.walletStatement.isLoading = false;
      state.walletStatement.error = error;
    },

    // create wallet id
    createWalletIdRequest: (
      state: wallet.WalletStateType,
      _action: PayloadAction<any>
    ) => {
      state.createWalletId.error = "";
      state.createWalletId.isLoading = true;
    },
    createWalletIdSuccess: (
      state: wallet.WalletStateType,
      _action: PayloadAction<common.ResponseGenerator>
    ) => {
      state.createWalletId.isLoading = false;
      state.createWalletId.walletDetails = _action?.payload?.data?.data;
    },
    createWalletIdError: (
      state: wallet.WalletStateType,
      { payload: error }: PayloadAction<string>
    ) => {
      state.createWalletId.isLoading = false;
      state.createWalletId.error = error;
    },

    // load money
    loadWalletMoneyRequest: (
      state: wallet.WalletStateType,
      _action: PayloadAction<any>
    ) => {
      state.loadWalletMoney.error = "";
      state.loadWalletMoney.isLoading = true;
    },
    loadWalletMoneySuccess: (
      state: wallet.WalletStateType,
      _action: PayloadAction<common.ResponseGenerator>
    ) => {
      state.loadWalletMoney.isLoading = false;
    },
    loadWalletMoneyError: (
      state: wallet.WalletStateType,
      { payload: error }: PayloadAction<string>
    ) => {
      state.loadWalletMoney.isLoading = false;
      state.loadWalletMoney.error = error;
    },
    // reset data
    resetWalletStatement: (state: wallet.WalletStateType) => {
      state.walletStatement = {
        count: 0,
        entity: "",
        items: [],
        total_count: 0,
        error: "",
        isLoading: false,
        isLastPageReached: false,
      };
    },
    setCoinsValue: (
      state: wallet.WalletStateType,
      action: PayloadAction<number>
    ) => {
      state.coinsValue = action.payload;
    },
    setWalletRuleEngine: (
      state: wallet.WalletStateType,
      action: PayloadAction<wallet.DynamicProgramType>
    ) => {
      state.walletRuleEngine = action.payload;
    },
    updateWalletAmount: (
      state: wallet.WalletStateType,
      action: PayloadAction<boolean>
    ) => {
      state.fetchWalletAmount = action.payload;
    },

    updateModalForEarnMoreCoins: (
      state: wallet.WalletStateType,
      action: PayloadAction<{
        modalVisible: boolean;
        type: string;
      }>
    ) => {
      state.showModalForEarnCoins = action.payload;
    },
    setCurrentUsedWalletMoney: (
      state: wallet.WalletStateType,
      action: PayloadAction<number>
    ) => {
      state.currentUsedWalletMoney = action.payload;
    },
  },
});

export const {
  fetchwalletOptionPlansRequest,
  fetchwalletOptionPlansSuccess,
  fetchwalletOptionPlansError,
  fetchWalletAmountRequest,
  fetchWalletAmountSuccess,
  fetchWalletAmountError,
  fetchWalletStatementRequest,
  fetchWalletStatementSuccess,
  fetchWalletStatementError,
  createWalletIdRequest,
  createWalletIdSuccess,
  createWalletIdError,
  loadWalletMoneyRequest,
  loadWalletMoneySuccess,
  loadWalletMoneyError,
  resetWalletStatement,
  setCoinsValue,
  setWalletRuleEngine,
  updateWalletAmount,
  updateModalForEarnMoreCoins,
  setCurrentUsedWalletMoney,
} = walletSlice.actions;

export default walletSlice.reducer;
